import { useFindAccountStatus, useSubmittedAccountSelector } from 'src/hooks';

import { AccountApplicationContent } from './AccountApplicationContent';
import { AccountInvestigationContent } from './AccountInvestigationContent';
import { LinkAccountContent } from './LinkAccountContent';

export const AccountStatus = () => {
  const { account } = useSubmittedAccountSelector();
  const { status, isAnyDocumentRequested, investigationList, application } = useFindAccountStatus({});

  if (status?.isPendingLinkError) {
    return (
      <LinkAccountContent
        status={status.label}
        isAnyDocumentRequested={isAnyDocumentRequested}
        customTypeLabel={account.customTypeLabel}
      />
    );
  }

  if (status?.isPendingEntityActivation) {
    return <AccountApplicationContent isLoading={application.isAccountApplicationLoading} status={status.label} />;
  }

  return (
    <AccountInvestigationContent isLoading={investigationList.isInvestigationListLoading} status={status?.label} />
  );
};
